import { Inject, Injectable } from '@angular/core';
import { DwOrmDataService, DwOrmDataServiceToken } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  AppMetaData,
  StudentCourseProgressStatusEntity
} from '../../../meta-data/app-meta-data.service';
import {
  CourseProgressStatusChip,
  createCourseProgressStatusChip
} from '../components/cards/course-progress-status.util';

@Injectable({ providedIn: 'root' })
export class StudentCourseProgressStatusService {

  private readonly statusChipsById$: Observable<{ [statusId: number]: CourseProgressStatusChip }>;

  constructor(
    @Inject(DwOrmDataServiceToken) private readonly dwOrmDataService: DwOrmDataService
  ) {
    const query = AppMetaData.StudentCourseProgressStatus.CreateQueryBuilder();

    query.addFilterAnd(filter => filter.Equal(attribute => attribute.Active, true));
    query.addOrderBy(attribute => attribute.SortOrder);

    this.statusChipsById$ = this.dwOrmDataService
      .executeQuery<StudentCourseProgressStatusEntity>(query)
      .pipe(
        map(statuses => statuses.reduce((statusChipsById, status) => {
          const statusId = status.StudentCourseProgressStatusId;
          const chip = createCourseProgressStatusChip(status);

          if (statusId && chip) {
            statusChipsById[statusId] = chip;
          }

          return statusChipsById;
        }, {} as { [statusId: number]: CourseProgressStatusChip })),
        shareReplay(1)
      );
  }

  getStatusChip(statusId: number): Observable<CourseProgressStatusChip | null> {
    return this.statusChipsById$.pipe(
      map(statusChipsById => statusChipsById[statusId] || null)
    );
  }
}
